export const STATUS_LABELS = {
    pending: 'Ожидает',
    in_progress: 'В работе',
    completed: 'Завершен',
    cancelled: 'Отменен',
    no_show: 'Не приехал',
};
